import { isNumberRangeValue, isRelativeDateRangeValue } from "app/pages/sales-intelligence/types/type-guards/range";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { dynamicFilterDataTypeMap } from "../types/dynamic-filter-options";
import type { DynamicFilterValue } from "../types/dynamic-filter-values";

export const parseDynamicFilterValue = (value: unknown): DynamicFilterValue | undefined => {
    if (!is.record(value)) {
        return undefined;
    }

    switch (value.dataType) {
        case dynamicFilterDataTypeMap.enumArray:
            return is.readonlyArray<string>(value.value) ? (value as DynamicFilterValue) : undefined;
        case dynamicFilterDataTypeMap.enum:
            return is.string(value.value) ? (value as DynamicFilterValue) : undefined;
        case dynamicFilterDataTypeMap.date:
            return isRelativeDateRangeValue(value.value) ? (value as DynamicFilterValue) : undefined;
        case dynamicFilterDataTypeMap.numberRange:
            return isNumberRangeValue(value.value)
                ? ({
                      ...value,
                      value: { from: value.value.from ?? undefined, to: value.value.to ?? undefined },
                  } as DynamicFilterValue)
                : undefined;
        default:
            return undefined;
    }
};

export const isDynamicFilterValueEmpty = (value: DynamicFilterValue): boolean => {
    switch (value.dataType) {
        case dynamicFilterDataTypeMap.enumArray:
            return value.value.length === 0;
        case dynamicFilterDataTypeMap.enum:
            return value.value === "";
        case dynamicFilterDataTypeMap.date:
            return !value.value.range || !value.value.rangeType;
        case dynamicFilterDataTypeMap.numberRange:
            return value.value.from == null && value.value.to == null;
    }
};
